import { useGT } from 'gt-react';
import type { NeedSplit } from '../utils/needSplit';

/**
 * Under the need row's quantity: what goes to back orders and what to stock,
 * and whether the total is a whole number of the vendor's packs (GEN-2938).
 */
export function NeedSplitNote({ split }: { split: NeedSplit }) {
  const gt = useGT();
  if (split.stock == null && split.pack == null) return null;
  return (
    <span className="flex flex-col items-end whitespace-nowrap text-[11px] leading-tight tabular-nums text-muted-foreground">
      {split.stock != null && (
        <span>
          {gt('{backOrder} BO + {stock} stock', {
            backOrder: split.backOrder,
            stock: split.stock,
            context:
              'buyer board need row: quantity for back orders plus quantity for stock',
          })}
        </span>
      )}
      {split.pack != null &&
        (split.pack.count == null ? (
          <span className="text-amber-700">
            {gt('Not a pack of {size}', {
              size: split.pack.size,
              context:
                'buyer board need row: total is not a whole number of vendor packs',
            })}
          </span>
        ) : (
          <span>
            {gt('{count} × {size} pack', {
              count: split.pack.count,
              size: split.pack.size,
              context: 'buyer board need row: total as whole vendor packs',
            })}
          </span>
        ))}
    </span>
  );
}
